import {Button} from '@heroui/react';
import IconComponent from 'components/IconComponent';
import {AppParamsContext} from 'contexts/AppParamsContext';
import {useContext} from 'react';
import SendVibration from 'utils/Helpers-v1/SendVibration';

function BarSoftButton({
	children,
	forceCustom,
	onClick,
	color = '',
	forceHideEndIcon = false,
	forceHideStartIcon = false,
	fullWidth = true,
	variant = '',
	size = '',
	radius = '',
	buttonName = '',
	onPress,
	isDisabled = false,
	isLoading = false,
	className = '',
	isIconOnly = false,
	customButtonParams,
	...props
}) {
	const {appParams} = useContext(AppParamsContext);
	const usedButtonName = buttonName || color || null;
	const buttonParams = customButtonParams ? customButtonParams : appParams?.buttons?.[usedButtonName] || {};
	const isFullWidth = forceCustom ? fullWidth : buttonParams?.fullWidth == null ? (fullWidth == null ? true : fullWidth) : buttonParams?.fullWidth;
	return (
		<Button
			radius={forceCustom ? radius || buttonParams?.radius || 'md' : buttonParams?.radius || radius || 'md'}
			onPress={() => {
				if (onClick && typeof onClick === 'function') {
					onClick();
					return;
				}
				if (onPress && typeof onPress === 'function') {
					onPress();
				}
				SendVibration('light');
			}}
			size={forceCustom ? size || buttonParams?.size || 'md' : buttonParams?.size || size || 'md'}
			fullWidth={isFullWidth}
			color={forceCustom ? color || buttonParams?.color || 'primary' : buttonParams?.color || color || 'primary'}
			variant={forceCustom ? variant || buttonParams?.variant || 'solid' : buttonParams?.variant || variant || 'solid'}
			className={`${className || ''} ${buttonParams?.className || ''} ${appParams?.styles?.fonts?.capitalize ? 'font-extrabold uppercase' : ''}`}
			isDisabled={isDisabled}
			isLoading={isLoading}
			isIconOnly={isIconOnly}
			{...props}
			startContent={
				props?.startContent ||
				(buttonParams?.startContent && forceHideStartIcon !== true && (
					<div className={`aspect-square w-auto h-[40%] `}>
						<IconComponent iconCode={buttonParams?.startContent || ''} className={'current'} />
					</div>
				))
			}
			endContent={
				props?.endContent ||
				(buttonParams?.endContent && forceHideEndIcon !== true && (
					<div className={`aspect-square w-auto h-[50%]  `}>
						<IconComponent ignoreWrapping={true} iconCode={buttonParams?.endContent || ''} className={'current'} />
					</div>
				))
			}>
			{children}
		</Button>
	);
}

export default BarSoftButton;
